import React, { forwardRef, useRef } from 'react'
import { Link } from 'react-router-dom';
import { useDropdownFilter } from '../Custom_Hooks/useDropdownFilter';
import { useDropdownKeyboardNavigation } from '../Custom_Hooks/useDropdownKeyboardNavigation';
import { useDropdownScroll } from '../Custom_Hooks/useDropdownScroll';
import { useDispatch } from 'react-redux';
import { closeModal, openModal } from '../../redux/actions/action-creator';


const DropdownDebitCredit = forwardRef(({ title, state, input_value, input_key, input_id, rawData, data, setData, inputRefs, setSubmitConfirm, style, index, handleDropdownClick }, ref) => {
    const dropdownRef = useRef(null)
    const dispatch = useDispatch();
    const { filteredData } = useDropdownFilter({
        dataList: rawData,
        searchInput: input_value,
        inputRef: ref,
    });
    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: filteredData,
        state,
        inputRef: ref,
        onItemSelect: (item) => {
            if (input_key === 'per') {
                setData((prevData) => {
                    const updatedData = { ...prevData };
                    updatedData.data_item = updatedData.data_item.map((item_data, i) =>
                        i === index ? {
                            ...item_data,
                            [input_key]: item?.name,
                            [input_id]: item?.id,
                        } : item_data
                    );

                    return updatedData;
                });
                dispatch(closeModal(`${input_key}${index}`))
            } else {
                setData({ ...data, [input_key]: item?.name })
                dispatch(closeModal(input_key))
                if (handleDropdownClick) {
                    handleDropdownClick(input_key, item?.name)
                }
            }
        },
        input_value
    });

    useDropdownScroll({ dropdownRef, selectedItemIndex });

    return (
        <div className={`dropdown_debit_credit_list`} style={{ position: "absolute", top: `-83px`, width: "105px", left: "0px", display: state ? 'block' : 'none', ...style }} >
            <div className='col dropdown_header'>
                {title ? title : 'Debit / Credit'}
            </div>
            <div id='data'>
                {filteredData?.length > 0 ? (
                    filteredData?.map((key, number) => {
                        const name = key?.name;
                        const index = name?.toLowerCase()?.indexOf(input_value?.toLowerCase());
                        return (
                            <Link
                                className={`list font-weight-bold ${number === selectedItemIndex ? 'selected' : ''}`}
                                id='list'
                                key={number}
                                onClick={() => {
                                    setSelectedItemIndex(number)
                                    if (number === selectedItemIndex) {
                                        setData({ ...data, [input_key]: name })
                                        handleDropdownClick(input_key, name)
                                    }
                                }}
                            >
                                {index !== -1 ? (
                                    < >
                                        {name.substring(0, index)}
                                        <span style={{ color: 'red' }}>{name.substring(index, index + input_value?.length)}</span>
                                        {name.substring(index + input_value?.length)}
                                    </>
                                ) : (
                                    name
                                )}
                            </Link>
                        );
                    })
                ) : (
                    <p style={{ color: 'red' }}>No matching items found</p>
                )}
            </div>
        </div>
    )
})

export default React.memo(DropdownDebitCredit)
